app.controller('LoginCtrl', ['$scope', '$rootScope', '$window', '$http', '$q', 'appFactory',
    function ($scope, $rootScope, $window, $http, $q, appFactory) {

    var allPromise = $q.all([

        // check login, jika ada session, maka pergi ke stage saat itu.
        $scope.checkLogin()
    ]);


    allPromise.then(function () {

    });

    $scope.user = {};

    // toggle password plaintext
    $scope.showPassword = false;
    $scope.inputType = 'password';
    $scope.toggleShowPassword = function () {
        $scope.showPassword = !$scope.showPassword;
        if ($scope.inputType == 'password')
            $scope.inputType = 'text';
        else
            $scope.inputType = 'password';
    }

    // saat tombol login di submit
    $scope.submit = function () {

        appFactory.postGetData(
            `/service/client.svc/LoginUser`,
            'POST',
            { UserLogin: $scope.user }
        ).then(function (data) {

            if (data.status == 200) {

                $scope.result = data.data.d;

                var SWALtranslate = $scope.SWALtranslate($scope.result.message);

                // login ok
                if ($scope.result.result) {

                    console.log($scope.result)

                    $scope.checkLoginStep($scope.result);
                    return;
                }

                // if user not activated, open sweet alert with footer
                if ($scope.result.message == "notactivated") {

                    Swal.fire({
                        title: SWALtranslate.title,
                        icon: 'warning',
                        footer: `<small><a id="resendOTP" >${SWALtranslate.footer}</a></small>`,
                        html: `${SWALtranslate.message}<div id="recaptcha" style="margin-top: 20px; display: flex; justify-content: center; align-items: center; flex-direction: column; overflow:hidden;"></div>`,
                        showConfirmButton: false,
                        timer: 0,
                        willOpen: function () {
                            grecaptcha.render('recaptcha', {
                                'sitekey': '6LdIc1orAAAAABMyF0NT8sK8ViSwOcWXc-U3y6mO'
                            });
                        },
                        preConfirm: function () {
                            if (grecaptcha.getResponse().length === 0) {
                                Swal.showValidationMessage(`Please verify that you're not a robot`)
                            }
                        }
                    })

                    //
                    $("#resendOTP").on("click", function () {

                        //ecnrypt email
                        var key = CryptoJS.enc.Utf8.parse('123456789qwertyu'); // Panjang 16 byte untuk AES-128
                        var iv = CryptoJS.enc.Utf8.parse('qwerty0987654321'); // Juga 16 byte

                        var plaintext = $scope.user.Email;

                        var encrypted = CryptoJS.AES.encrypt(plaintext, key, {
                            iv: iv,
                            mode: CryptoJS.mode.CBC,
                            padding: CryptoJS.pad.Pkcs7
                        });

                        //captcha
                        var challenge = grecaptcha.getResponse();
                        if (!challenge) {
                            alert("Mohon ulangi centang captcha");
                            return false;
                        }

                        //send request resendOTP
                        var data = {
                            Email: encrypted.toString(),
                            challenge: challenge
                        }

                        //
                        var urlsvc = 'service/client.svc/resendOTP'// 1
                        var preconfirmtranslate = "resendactivationlink"; // 2 
                        var postData = { User: data }; // 3
                        var method = "POST"; // 4
                        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

                            if (issuccess) // 6 
                                $window.location.href = "#/login";
                        });
                    });
                    return
                }

                // login not ok
                $rootScope.GlobalAlert('warning', SWALtranslate.title, SWALtranslate.message, 0);
            }
        });
    };
}]);
